import PermissionGuard from 'components/Global/PermissionGuard'; 
import ShiftComponent from 'components/Settings/Masters/Shift';

export const ShiftMaster = () => {
	return (
		<PermissionGuard permission="Allow_Shift_Master">
			<ShiftComponent />
		</PermissionGuard>
	);
};
